import React from "react";
import { Link } from "react-router-dom";
import "./featurePost.css";

const FeaturedPost = ({ ft }) => {
  if (!ft || ft.length === 0) return null;
  let fpost = ft[0];

  return (
    <div className="fpost d-flex flex-column ">
      {fpost.photo && (
        <div className="fpostImageWrapper position-relative shadow-elevation-lightbg-medium">
          <Link to={`/post/${fpost?.documentId}`} className="link">
            <img
              className=""
              src={`${process.env.REACT_APP_UPLOAD_URL}${
                fpost.photo?.formats?.small?.url || fpost.photo?.url
              }`}
              alt=""
            />

            <div className="fpostOverlayText position-absolute">
              <div className="fpostStats d-flex w-100 justify-content-end">
                <span className="stat" title="Total Likes">
                  <i className="fa-regular fa-heart"></i>
                  {fpost.likes}
                </span>
              </div>

              <div className="d-flex flex-column justify-content-center">
                <h2 className="fpostTitle">{fpost.title}</h2>

                <div className="d-flex w-100 justify-content-end align-items-center gap-1 readmore-wrapper">
                  <span className="readmore">Read more</span>
                  <i className="fa-solid fa-circle-right readmore"></i>
                </div>
              </div>
            </div>
          </Link>
        </div>
      )}

      <div className="d-flex flex-row justify-content-between">
        <div className="fpostCats">
          {fpost.categories?.map((c, index) => (
            <span key={`fpostCat${index}`} className="fpostCat">
              <Link className="link" to={`/posts?cat=${c.documentId}`}>
                {c.name}
              </Link>
            </span>
          ))}
        </div>
        <Link to={`/posts?createdAt=${fpost.createdAt}`} className="link">
          <span className="fpostDate">
            {new Date(fpost.createdAt).toDateString()}
          </span>
        </Link>
      </div>

      <p className="fpostDesc">{fpost.description}</p>
    </div>
  );
};

export default FeaturedPost;
